module.exports = __webpack_public_path__ + "static/media/stripe_payments.a149a642.svg";